import { format } from 'date-fns'
import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { BlockResponse } from '@opallabs/api'
import { richTextDocumentResourceFactory as v3RichTextDocumentResourceFactory } from '../../v3/resource_objects/rich_text_document'
import { userResourceFactory as v3UserResourceFactory } from '../../v3/resource_objects/user'
import { relatedBoardFactory } from '../components/related_board'

export const blockDetailFactory: Factory<BlockResponse> =
  Factory.define<BlockResponse>(({ sequence }) => {
    return {
      data: {
        boards: [relatedBoardFactory.build()],
        details: {
          category: null,
          category_type: null,
          color: null,
          custom_field_values: [],
          custom_fields: [],
          description: null,
          image_id: null,
          inherited_custom_field_values: [],
          in_support_of_category_type_ids: [],
          last_updated_date: new Date().toISOString(),
          connectors: [],
        },
        duration: 'P30D',
        effective_privacy: 'some_but_not_all',
        id: uuidV4(),
        is_private: true,
        is_template: false,
        is_workspace_wide_template: false,
        child_plan_id: null,
        owner_id: v3UserResourceFactory.build().id,
        paired_moment_id: null,
        rich_text_document_id: v3RichTextDocumentResourceFactory.build().id,
        start_date: format(new Date(), 'yyyy-MM-dd'),
        template_description: null,
        template_name: null,
        title: `Mock Block ${sequence}`,
        view_id: uuidV4(),
      },
    } satisfies BlockResponse
  })
